import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  actions as detailTransactionActions,
  detailTransactionSelector,
} from "reducers/detailTransaction";
import { DetailTransactionCancelItemType } from "sagas/types/detailTransactions";
import { AppDispatch, RootState } from "store";
import { ReasonList } from "../reasonList/ReasonList";
import "./reasonsCanceled.scss";
import { ReasonCanceledPropsType } from "./types";
import { FilterTransactionsType } from "sagas/types/transactions";
import {
  actions as transactionActions,
  transactionsSelector,
} from "reducers/transactions";
import "../i18n";
import { useTranslation } from "react-i18next";
import { BackButton } from "../backButton/BackButton";

const ReasonsCanceled: React.FC<ReasonCanceledPropsType> = ({
  back,
  next,
  messages,
  reasonsCanceledConfirm,
  setMessageSelected,
  getMessages,
  detailTransaction,
  resetMessage,
  selectedMessage,
  filters,
  filtersExtra,
  getTransactions,
  isModalOpen,
}): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isModalOpen) {
      resetMessage();
      getMessages({
        id: detailTransaction.transaction.id,
        callBack: () => {
          getTransactions({
            ...filters,
            offset: 0,
          });
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = (message: DetailTransactionCancelItemType) => {
    setMessageSelected(message);
    next(reasonsCanceledConfirm);
  };
  return (
    <div className="container-finish">
      <BackButton back={back} />
      <div className="content-finish">
        <p className="modal-transaction-reasonsCanceled-subtitle">
          {t("detailTransaction:selectCacelationReason")}
        </p>
        <ReasonList
          messages={messages}
          selectedMessage={selectedMessage}
          handleClick={handleClick}
        ></ReasonList>
        <div className="modal-reasonsCanceled-difuminar"></div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  detailTransaction: detailTransactionSelector(state).detailTransaction,
  messages: detailTransactionSelector(state).messages,
  selectedMessage: detailTransactionSelector(state).messageSelected,
  filters: transactionsSelector(state).filters,
  isModalOpen: transactionsSelector(state).detailTransactionModalOpen,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTransactions: (params: FilterTransactionsType) => {
    dispatch(transactionActions.getTransactionsRequest(params));
  },
  getMessages: (id: string) => {
    dispatch(detailTransactionActions.getDetailTransactionMenssagesRequest(id));
  },
  resetMessage: () => {
    dispatch(detailTransactionActions.getResetMessageDetailTransaccions());
  },
  setMessageSelected: (message: DetailTransactionCancelItemType) => {
    dispatch(detailTransactionActions.setMessageSelected(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReasonsCanceled);
